import * as React from "react"
import { useContext, useState } from "react"
import { Link } from "react-router-dom"
import Slider from "react-slick"
import "../../slickslider.css"
import { Context } from "../../store/store"
import { gatherChildren, getText } from "../strapi"

interface SoGehtsProps {
	type?: any
}

const Sogehts: React.FC<SoGehtsProps> = ({ type = "" }) => {
	const { globalState } = useContext(Context)
	const [arrowVisibilityPrev, setArrowVisbilityPrev] = useState(false)
	const [arrowVisibilityNext, setArrowVisbilityNext] = useState(true)
	var settings = {
		dots: false,
		infinite: false,
		speed: 100,
		slidesToShow: 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		autoplay: true,
		autoplaySpeed: 4000,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: false,
					dots: false,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					dots: false,
					arrows: true,
					speed: 300,
					infinite: false,
					slidesToScroll: 1,
				},
			},
		],
		afterChange: current => {
			switch (current) {
				case 0:
					setArrowVisbilityPrev(false)
					setArrowVisbilityNext(true)
					break
				case 10:
					setArrowVisbilityNext(false)
					// code block
					break
				default:
					setArrowVisbilityPrev(true)
					setArrowVisbilityNext(true)
			}
		},
	}
	function CustomNextArrow(props) {
		const { className, style, onClick } = props
		return (
			<>
				{!arrowVisibilityNext && (
					<div
						className={className + (arrowVisibilityNext ? " flex" : " hidden")}
						style={{
							alignItems: "center",
							justifyItems: "center",
							width: "40px",
							height: "40px",
							position: "absolute",
							right: "20px",
							backgroundImage: "none",
							transform: "scaleX(1)",
						}}
						onClick={onClick}
					>
						<svg width="24" height="38" viewBox="0 0 24 38" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M3 3L19 19L3 35" stroke="white" stroke-width="6" />
						</svg>
					</div>
				)}
			</>
		)
	}

	function CustomPrevArrow(props) {
		const { className, style, onClick } = props
		return (
			<div
				className={className + (arrowVisibilityPrev ? " flex" : " hidden")}
				style={{
					alignItems: "center",
					justifyItems: "end",
					width: "40px",
					height: "40px",
					position: "absolute",
					left: "20px",
					backgroundImage: "none",
					transform: "",
				}}
				onClick={onClick}
			>
				<svg width="24" height="38" viewBox="0 0 24 38" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 3L5 19L21 35" stroke="white" stroke-width="6" />
				</svg>
			</div>
		)
	}

	return (
		<div className="js-sogehts   relative  z-10  bg-[url(/src/bgimages/hero-bubbles-mobile.png)] md:bg-[url(/src/bgimages/sogehts-bubbles.png)] bg-[length:80%_auto] md:bg-[length:100%_auto] bg-center md:bg-top   bg-no-repeat pb-20 lg:pb-[5.5rem]">
			<div className={"mx-auto max-w-[1400px] "}>
				<h2 className="mb-4 pt-24 md:pt-[57px] text-white">{getText(globalState.strapi.homepage.sogehtsHeadline, "sogehtsHeadline")}</h2>
				<Slider {...settings} className="mx-auto max-w-[966px] text-center font-Veener text-[30px] text-white">
					<div>
						<img src={"/images/sogehts-first.png"} className="z-2 relative mx-auto  max-w-[75%] md:max-w-[95%] " />
						<div className="-mt-5 max-w-[180px] md:max-w-[180px] mx-auto leading-tight">{getText(globalState.strapi.homepage.sogehts1, "sogehts1")}</div>
					</div>
					<div>
						<img src={"/images/sogehts-second.png"} className="z-2 relative mx-auto   max-w-[75%] md:max-w-[95%] " />
						<div className="-mt-5 max-w-[180px] md:max-w-[180px]]  mx-auto  leading-tight">{getText(globalState.strapi.homepage.sogehts2, "sogehts2")}</div>
					</div>
					<div>
						<img src={"/images/sogehts-third.png"} className="z-2 relative mx-auto   max-w-[75%] md:max-w-[95%] " />
						<div className="-mt-5 max-w-[180px] md:max-w-[180px]  mx-auto  leading-tight">{getText(globalState.strapi.homepage.sogehts3, "sogehts3")}</div>
					</div>
				</Slider>
			</div>
		</div>
	)
}

export default Sogehts
